import { render } from "./App.vue?vue&type=template&id=2b56bd92"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2b56bd92&lang=css"
script.render = render

export default script